import { useEffect } from 'react'
import { NavLink, Outlet } from 'react-router'
import { useBahasa } from '../../app/i18n'
import { useSesi } from '../../app/auth'
import PemilihBahasa from '../../app/PemilihBahasa'
import Merek from '../../shared/ui/Merek'

const cx = (...a) => a.filter(Boolean).join(' ')

/**
 * Lima menu ditetapkan rancangan 7 September; SATU yang punya backend.
 *
 * Empat sisanya ditampilkan MATI dan bertanda, bukan disembunyikan dan bukan
 * dibuat bisa diklik. Disembunyikan berarti bentuk konsolnya berubah tiap kali
 * satu bagian selesai, dan orang harus belajar ulang letak segalanya. Dibuat bisa
 * diklik berarti menu yang membuka halaman kosong — dan itu pelajaran yang sudah
 * dibayar sekali di layar Perlu Dijawab: tombol yang pasti gagal lebih buruk
 * daripada tidak ada tombol.
 */
// DUA GRUP, mengikuti mockup: "Operasi" dan "Data induk". Versi pertama fase B
// membuatnya satu daftar rata — lebih sederhana, dan salah: pengelompokan itu yang
// membedakan "yang dikerjakan tiap hari" dari "yang jarang disentuh", dan orang
// mencari menu berdasarkan kelompoknya sebelum berdasarkan namanya.
const GRUP = [
  {
    label: 'adm.grupOperasi',
    menu: [
      { ke: '/tenant', kunci: 'adm.navTenant', siap: true },
      { ke: '/pemakaian', kunci: 'adm.navPemakaian', siap: true },
      { ke: '/jalur-masuk', kunci: 'adm.navJalurMasuk', siap: true },
    ],
  },
  {
    label: 'adm.grupDataInduk',
    menu: [
      { ke: '/katalog', kunci: 'adm.navKatalog', siap: true },
      { ke: '/sistem', kunci: 'adm.navSistem', siap: true },
    ],
  },
]

export default function ShellSmovaAdmin() {
  const { t } = useBahasa()
  const { sesi, keluar } = useSesi()

  // Aksen navy. Operator yang membuka konsolnya sendiri dan dashboard tenant di
  // dua tab harus tahu yang mana tanpa membaca judulnya.
  useEffect(() => {
    document.documentElement.dataset.shell = 'smova-admin'
    return () => { delete document.documentElement.dataset.shell }
  }, [])

  return (
    <div className="grid min-h-full md:grid-cols-[214px_minmax(0,1fr)]">
      <nav className="bg-surface border-b md:border-b-0 md:border-r border-line flex flex-col gap-5 py-4 md:sticky md:top-0 md:h-screen">
        <Merek antarmuka={t('app.smovaAdmin')} />

        {GRUP.map((g) => (
        <div key={g.label} className="flex flex-col gap-px">
          <div className="px-[18px] pb-1 text-[10px] font-semibold uppercase
                          tracking-[.07em] text-ink3">
            {t(g.label)}
          </div>
          {g.menu.map((m) =>
            m.siap ? (
              <NavLink
                key={m.ke}
                to={m.ke}
                className={({ isActive }) =>
                  cx(
                    'flex items-center justify-between gap-2 px-[18px] py-[7px] text-[13px] border-l-2',
                    isActive
                      ? 'text-ink bg-surface2 border-accent font-semibold'
                      : 'text-ink2 border-transparent font-medium hover:bg-surface2 hover:text-ink',
                  )
                }
              >
                {t(m.kunci)}
              </NavLink>
            ) : (
              <span
                key={m.ke}
                aria-disabled="true"
                title={t('adm.belumTersedia')}
                className="flex items-center justify-between gap-2 px-[18px] py-[7px]
                           text-[13px] border-l-2 border-transparent text-ink3 cursor-not-allowed"
              >
                {t(m.kunci)}
                <i className="not-italic text-[9.5px] uppercase tracking-[.06em] text-ink3
                              border border-line rounded px-1 py-px">
                  {t('adm.segera')}
                </i>
              </span>
            ),
          )}
        </div>
        ))}

        <div className="mt-auto px-[18px] flex flex-col gap-2.5">
          <PemilihBahasa />
          <div className="flex items-end justify-between gap-2">
            <div className="min-w-0">
              <b className="block text-[12px] font-semibold truncate">{sesi?.nama}</b>
              {/* Nilai kolomnya kini SAMA dengan yang dibaca orang sejak migrasi
                  0013 — `tenant_admin`, `tenant_marketing`, `smova_admin`. Pemetaan
                  ini tinggal soal huruf besar dan spasi, bukan lagi dua kosakata.
                  Kunci yang tidak dikenal jatuh ke namanya sendiri (lihat i18n.jsx),
                  jadi peran baru akan terlihat salah di layar alih-alih diam. */}
              <span className="text-[11px] text-ink3">
                {t(`peran.${sesi?.peran}`)}
              </span>
            </div>
            <button
              onClick={keluar}
              className="text-[11px] text-ink3 hover:text-ink underline bg-transparent border-0 cursor-pointer p-0"
            >
              {t('umum.keluar')}
            </button>
          </div>
        </div>
      </nav>

      <main className="min-w-0">
        <div className="p-6 max-w-[1240px] w-full flex flex-col gap-5">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
